import { render, staticRenderFns } from "./TiersForm.vue?vue&type=template&id=27b8f74d&scoped=true"
import script from "./TiersForm.vue?vue&type=script&lang=js"
export * from "./TiersForm.vue?vue&type=script&lang=js"
import style0 from "./TiersForm.vue?vue&type=style&index=0&id=27b8f74d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8f74d",
  null
  
)

export default component.exports